import Typography from '@mui/material/Typography';
import type { Account } from '@openx/types/account';
import type { Provider } from '@openx/types/provider';
import { useTranslation } from 'react-i18next';

type Props = {
  account?: Pick<Account, 'name'> | null;
  provider?: Pick<Provider, 'name'> | null;
};

export const OwnerCell = ({ account, provider }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2">
        <Typography component="span" color="textSecondary" sx={{ marginRight: 1 }}>
          {t('Organization')}:
        </Typography>
        {account ? account.name : null}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" color="textSecondary" sx={{ marginRight: 1 }}>
          {t('Provider')}:
        </Typography>
        {provider ? provider.name : null}
      </Typography>
    </>
  );
};
